import React from 'react';
import { Box, Typography } from '@mui/material';
import CompactCVDocument, { CompactFooter } from './CompactCV';
import {
  PAGE_WIDTH_MM, PAGE_MARGIN_MM, CONTENT_HEIGHT_MM,
} from '../../config/compactCV';

/**
 * Vit A4-yta med det kompakta dokumentet.
 *
 * Arket ritas alltid ut i sin fulla höjd – alla valda sidor, oavsett om de
 * fylls eller inte. En halvfylld sida ska inte kunna misstas för ett kortare
 * dokument. Varje sidruta är 194 × 281 mm, alltså exakt den tryckbara ytan
 * vid 8 mm marginal.
 *
 * Sidfoten skrivs ut i varje sidas nedre marginal via @page (se CompactCV).
 * Skärmvyn flödar sidorna utan marginaler emellan, så här ritas den bara i
 * arkets nedre marginal, där den hamnar på sista sidan.
 */
export default function CompactSheet({
  docRef, persons, settings, company, docTitle, subTitle, editedFields, onToggleExpand,
}) {
  const pages = Math.max(1, settings.pages);
  const totalHeightMm = pages * CONTENT_HEIGHT_MM + 2 * PAGE_MARGIN_MM;

  const pageMarkers = Array.from({ length: pages }, (_, k) => (
    <React.Fragment key={k}>
      {k > 0 && (
        <Box className="no-print" sx={{
          position: 'absolute', left: 0, right: 0,
          top: `${PAGE_MARGIN_MM + k * CONTENT_HEIGHT_MM}mm`,
          borderTop: '1px dashed #FF6B00', pointerEvents: 'none',
        }} />
      )}
      <Typography className="no-print" variant="caption" sx={{
        position: 'absolute', right: 6,
        top: `calc(${PAGE_MARGIN_MM + k * CONTENT_HEIGHT_MM}mm + 2px)`,
        color: '#FF6B00', fontSize: 10, pointerEvents: 'none',
      }}>
        sida {k + 1} av {pages}
      </Typography>
    </React.Fragment>
  ));

  return (
    <Box id="cv-content" sx={{
      position: 'relative',
      width: `${PAGE_WIDTH_MM}mm`,
      minHeight: `${totalHeightMm}mm`,
      mx: 'auto',
      bgcolor: '#ffffff',
      p: `${PAGE_MARGIN_MM}mm`,
      boxShadow: 3,
      '@media print': { width: 'auto', minHeight: 0, p: 0, boxShadow: 'none' },
    }}>
      <CompactCVDocument
        docRef={docRef}
        persons={persons}
        settings={settings}
        company={company}
        docTitle={docTitle}
        subTitle={subTitle}
        editedFields={editedFields}
        onToggleExpand={onToggleExpand}
      />
      {pageMarkers}
      <Box className="no-print" sx={{
        position: 'absolute', left: `${PAGE_MARGIN_MM}mm`, right: `${PAGE_MARGIN_MM}mm`,
        bottom: 0, height: `${PAGE_MARGIN_MM}mm`, pointerEvents: 'none',
      }}>
        <CompactFooter company={company} />
      </Box>
    </Box>
  );
}
